import CInput2 from "@/components/controls2/Input";
import CButton2 from "@/components/controls2/Button";
import CButton from "@/components/controls/button";

import { getRange } from "@/utils/date/ranges";

const exceptTooltip = {
    disabledText: "Фильтр по всем значениям в справочнике, кроме выбранных",
    activeText: "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
    notActiveText: "Включить фильтр по всем значениям в справочнике, кроме выбранных",
};

export default {
    components: {
        CInput2,
        CButton2,
        CButton,
    },
    data() {
        return {
            inited: false,
            open: false,

            exceptTooltip,

            collections: {
                filials: [],
                positions: [],
                types: [],
            },

            form: {
                period: "",
                periodStart: "",
                periodEnd: "",

                filials: [],
                filialsExcept: false,
                positions: [],
                positionsExcept: false,
                types: [],
                typesExcept: false,
                name: "",
            },
        };
    },

    created() {
        Promise.all([
            this.$store
                .dispatch("filters/loadFilials", {
                    own: "viewVacations",
                    all: "viewVacationsAll",
                })
                .then((filials) => {
                    this.collections.filials = filials;
                })
                .catch((err) => {
                    console.error("FILIALS ERROR:", err);
                }),
            this.$store.dispatch("filters/loadPositions").then((positions) => {
                this.collections.positions = positions;
            }),
            this.$store.dispatch("referenceVacationTypes/loadTypes").then((types) => {
                this.collections.types = [
                    ...types.map((t) => ({
                        value: t.id,
                        label: t.name,
                    })),
                ];
            }),
        ]).then(() => {
            this.setDefaultParams();
            this.inited = true;

            this.$nextTick(() => {
                this.setPeriod();
            });

            this.$emit("inited");
        });
    },

    mounted() {
        this.setPeriod();
    },

    methods: {
        setPeriod() {
            if (this.form.periodStart && this.form.periodEnd) {
                this.$refs.periodPicker.period.start.input = this.form.periodStart;
                this.$refs.periodPicker.period.end.input = this.form.periodEnd;

                const range = getRange(this.form.periodStart, this.form.periodEnd);
                this.$refs.periodPicker.dateValue = range;
            }
        },

        setDefaultParams() {
            const sp = this.$route.query;
            if (sp.periodStart && sp.periodEnd) {
                this.form.periodStart = sp.periodStart;
                this.form.periodEnd = sp.periodEnd;
                this.form.period = getRange(this.form.periodStart, this.form.periodEnd);
            }
            if (sp.filials) {
                this.form.filials = sp.filials
                    .split(",")
                    .map((id) => this.collections.filials.find((el) => el.value.toString() === id.toString()))
                    .filter(Boolean);

                this.form.filialsExcept = sp.filialsExcept.toString() === "1";
            }
            if (sp.positions) {
                this.form.positions = sp.positions
                    .split(",")
                    .map((id) => this.collections.positions.find((el) => el.value.toString() === id.toString()))
                    .filter(Boolean);

                this.form.positionsExcept = sp.positionsExcept.toString() === "1";
            }
            if (sp.types) {
                this.form.types = sp.types
                    .split(",")
                    .map((id) => this.collections.types.find((el) => el.value.toString() === id.toString()))
                    .filter(Boolean);

                this.form.typesExcept = sp.typesExcept.toString() === "1";
            }

            if (sp.name) {
                this.form.name = sp.name;
            }
        },

        saveParams() {
            const params = this.getFilterParams();

            const { query } = this.$route;

            const sp = {
                ...query,
                periodStart: params.periodStart,
                periodEnd: params.periodEnd,
                filials: params.filials.join(","),
                filialsExcept: params.filialsExcept ? 1 : 0,
                positions: params.positions.join(","),
                positionsExcept: params.positionsExcept ? 1 : 0,
                types: params.types.join(","),
                typesExcept: params.typesExcept ? 1 : 0,
                name: params.name,
            };

            this.$router
                .replace({
                    name: "vacations-chart",
                    query: sp,
                })
                .catch(() => {});
        },

        getFilterParams() {
            return {
                periodStart: this.form.periodStart,
                periodEnd: this.form.periodEnd,
                filials: this.form.filials.map((i) => i.value),
                filialsExcept: this.form.filialsExcept,
                positions: this.form.positions.map((i) => i.value),
                positionsExcept: this.form.positionsExcept,
                types: this.form.types.map((i) => i.value),
                typesExcept: this.form.typesExcept,
                name: this.form.name.trim(),
            };
        },

        getParams() {
            const filters = this.getFilterParams(); 

            const params = {
                worker_name: filters.name,
            };

            if (filters.name) {
                params.name = filters.name;
            }

            if (filters.periodStart && filters.periodEnd) {
                params.periodStart = filters.periodStart;
                params.periodEnd = filters.periodEnd;
            }

            if (filters.filials.length) {
                params.filials = {
                    values: filters.filials,
                    search_type: filters.filialsExcept ? 2 : 1,
                };
            }
            if (filters.positions.length) {
                params.posts = {
                    values: filters.positions,
                    search_type: filters.positionsExcept ? 2 : 1,
                };
            }
            if (filters.types.length) {
                params.types = {
                    values: filters.types,
                    search_type: filters.typesExcept ? 2 : 1,
                };
            }

            return params;
        },

        reset() {
            this.form.period = "";
            this.$refs.periodPicker.periodReset();
            this.form.filials = [];
            this.form.filialsExcept = false;
            this.form.positions = [];
            this.form.positionsExcept = false;
            this.form.types = [];
            this.form.typesExcept = false;
            this.form.name = "";
            this.$nextTick(() => this.apply());
        },

        apply() {
            this.$emit("apply");
        },
    },

    watch: {
        "form.filials": function (v) {
            if (!v.length) {
                this.form.filialsExcept = false;
            }
        },
        "form.positions": function (v) {
            if (!v.length) {
                this.form.positionsExcept = false;
            }
        },
        "form.types": function (v) {
            if (!v.length) {
                this.form.typesExcept = false;
            }
        },

        "form.period": function () {
            if (this.$refs.periodPicker) {
                this.form.periodStart = this.$refs.periodPicker.period.start.input;
                this.form.periodEnd = this.$refs.periodPicker.period.end.input;
            }
        },
    },
};
